/**
 * Site-wide switches for seasonal offers.
 *
 * SHOW_SUMMER_PASS hides every link and button to the Summer Day Pass —
 * header, menus, home page and footer. The /summer-pass page itself stays
 * live, so links already shared, and confirmation emails, still work.
 * Set it back to true to bring the buttons back.
 */
export const SHOW_SUMMER_PASS = false;

/**
 * SHOW_MIDTERM_PASS shows the "Mid-Term Break" button, right after Gift
 * Cards in the header, the mobile menu and the quick menu. It opens the day
 * pass page at /daypass. Set to false once the break is over.
 */
export const SHOW_MIDTERM_PASS = false;
export const MIDTERM_PASS_LABEL = 'Mid-Term Break';
